import React from "react";

/* ── Image imports (replace filenames with your actual files) ── */
import HeroBgImg       from "../../../asset/images/about/hero-bg.webp";
import ContentImg1     from "../../../asset/images/about/content-img-1.webp";
import ContentImg2     from "../../../asset/images/about/content-img-2.webp";
import ContentImg3     from "../../../asset/images/about/content-img-3.webp";
import Section4Img     from "../../../asset/images/about/section4-img.webp";
import BcSepIcon      from "../../../asset/images/about/breadcrumb-separator.svg";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .au { font-family: 'Poppins', sans-serif; font-size: 14px; color: #202020; background: #fff; }

  /* ══════════════════════════════════════════
     1. HERO
  ══════════════════════════════════════════ */
  .au-hero {
    position: relative;
    width: 100%;
    height: 460px;
    overflow: hidden;
  }

  .au-hero-bg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    display: block;
  }

  /* dark overlay */
  .au-hero-overlay {
    position: absolute;
    inset: 0;
    // background: linear-gradient(
    //   to right,
    //   rgba(0,0,0,0.72) 0%,
    //   rgba(0,0,0,0.35) 60%,
    //   rgba(0,0,0,0.10) 100%
    // );
  }

  .au-hero-content {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
   justify-content: center;
    padding: 0 102px 48px 102px;
    max-width: 1600px;
    margin: 0 auto;
    left: 0; right: 0;
  }

  .au-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px;
    font-weight: 600;
    color: #ffffff;
    line-height: 120%;
    margin-bottom: 15px;
  }

  .au-hero-divider {
    width: 559px;
    height: 2px;
    background: #EB2019;
    margin-bottom: 15px;
    border: none;
  }

  .au-hero-desc {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: rgba(255,255,255,0.85);
    line-height: 140%;
    max-width: 500px;
  }

  /* ══════════════════════════════════════════
     2. BREADCRUMB
  ══════════════════════════════════════════ */
  .au-breadcrumb {
    width: 100%;
    padding: 40px 0px 0px 0px;
  
  }

  .au-breadcrumb-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
    display: flex;
    align-items: center;
    gap: 0;
    flex-wrap: wrap;
  }

  .au-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 500;
    color: #202020;
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: 14px;
    transition: color 0.15s;
  }

  .au-bc-item:hover { color: #EB2019; }

  .au-bc-sep {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    // background: #EB2019;
    border-radius: 50%;
    margin: 0 8px;
    flex-shrink: 0;
  }

  .au-bc-sep svg { display: block; }

  .au-bc-item.active {
    color: #202020;
    font-weight: 500;
  }

  /* ══════════════════════════════════════════
     SHARED INNER
  ══════════════════════════════════════════ */
  .au-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
  }

  /* ══════════════════════════════════════════
     3. CONTENT SECTION — left text, right images
  ══════════════════════════════════════════ */
  .au-section3 {
    padding: 80px 0;
  }

  .au-section3-grid {
    display: flex;
    gap: 120px;
    align-items: flex-start;
  }

  /* Left column */
  .au-s3-left {
    flex: 0 0 652px;
  }

  .au-s3-title {
    font-family: 'Poppins', sans-serif;
    font-size: 24px;
    font-weight: 600;
    color: #202020;
    line-height: 140%;
    margin-bottom: 15px;
  }

  .au-s3-para {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #202020;
    line-height: 1.7;
  }

  .au-s3-para + .au-s3-para {
    margin-top: 8px;
  }

  /* Right column */
  .au-s3-right {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 30px;
    width:100%;
  }

  /* Top row: 2 vertical images side by side */
  .au-s3-img-row1 {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
  }

  .au-s3-img-vertical {
    width: 100%;
    height: 300px;
    object-fit: cover;
    border-radius: 10px;
    display: block;
  }

  /* Bottom row: 1 horizontal image */
  .au-s3-img-horizontal {
    width: 100%;
    height: 260px;
    object-fit: cover;
    border-radius: 10px;
    display: block;
  }

  /* ══════════════════════════════════════════
     4. ABOUT COMPANY — bg #F5F5F5, img left, text right
  ══════════════════════════════════════════ */
  .au-section4 {
    background: #F5F5F5;
    padding: 80px 0;
  }

  .au-section4-grid {
    display: flex;
    gap: 60px;
    align-items: center;
  }

  /* Left: image */
  .au-s4-img-wrap {
    flex: 0 0 683px;
  }

  .au-s4-img {
    width: 100%;
    height: 500px;
    object-fit: cover;
    border-radius: 10px;
    display: block;
  }

  /* Right: text */
  .au-s4-text {
    flex: 1;
  }

  .au-s4-title {
    font-family: 'Poppins', sans-serif;
    font-size: 24px;
    font-weight: 600;
    color: #202020;
    line-height: 140%;
    margin-bottom: 15px;
  }

  .au-s4-para {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #202020;
    line-height: 160%;
  }

  .au-s4-para + .au-s4-para {
    margin-top: 8px;
  }
  /* ══════════════════════════════════════════
     RESPONSIVE — TABLET (max-width: 768px)
  ══════════════════════════════════════════ */
  @media (max-width: 768px) {
  .au-hero             { height: 300px; }
    .au-hero-content     { padding: 0 32px 36px 32px;  justify-content: center; }
    .au-hero-title       { font-size: 30px; }
    .au-hero-divider     { width: 100%; max-width: 390px; }
    .au-hero-desc        { font-size: 14px; max-width: 390px;  }
 
    .au-breadcrumb       { padding: 28px 0 0 0; }
    .au-breadcrumb-inner { padding: 0 32px; }
    .au-inner            { padding: 0 32px; }
 
    .au-section3         { padding: 56px 0; }
    .au-section3-grid    { flex-direction: column; gap: 40px; }
    .au-s3-left          { flex: none; width: 100%; }
    .au-s3-title         { font-size: 22px; }
    .au-s3-para          { font-size: 15px; }
    .au-s3-img-vertical  { height: 240px; }
    .au-s3-img-horizontal { height: 200px; }
 
    .au-section4         { padding: 56px 0; }
    .au-section4-grid    { flex-direction: column; gap: 36px; }
    .au-s4-img-wrap      { flex: none; width: 100%; }
    .au-s4-img           { height: 360px; }
    .au-s4-title         { font-size: 22px; }
    .au-s4-para          { font-size: 15px; }
  }
 
  /* ══════════════════════════════════════════
     RESPONSIVE — MOBILE (max-width: 480px)
  ══════════════════════════════════════════ */
  @media (max-width: 480px) {
    .au-hero             { height: 400px; }
    .au-hero-content     { padding:  16px;     justify-content: center;  }
    .au-hero-title       { font-size: 24px; margin-bottom: 15px; }
    .au-hero-divider     { width: 100%; max-width: 240px; margin-bottom: 12px; }
    .au-hero-desc        { font-size: 14px; max-width: 250px; line-height:120%;}
 
    .au-breadcrumb       { padding: 20px 0 0 0; }
    .au-breadcrumb-inner { padding: 0 16px; }
    .au-bc-item          { font-size: 13px; gap: 8px; }
    .au-bc-sep           { width: 18px; height: 18px; margin: 0 4px; }
    .au-inner            { padding: 0 16px; }
 
    .au-section3         { padding: 40px 0; }
    .au-section3-grid    { flex-direction: column; gap: 28px; }
    .au-s3-left          { flex: none; width: 100%; }
    .au-s3-title         { font-size: 19px; margin-bottom: 12px; }
    .au-s3-para          { font-size: 14px; }
    .au-s3-img-row1      { gap: 12px; }
    .au-s3-img-vertical  { height: 180px; border-radius: 8px; }
    .au-s3-img-horizontal { height: 160px; border-radius: 8px; }
    .au-s3-right         { gap: 12px; }
 
    .au-section4         { padding: 40px 0; }
    .au-section4-grid    { flex-direction: column; gap: 24px; }
    .au-s4-img-wrap      { flex: none; width: 100%; }
    .au-s4-img           { height: 260px; border-radius: 8px; }
    .au-s4-title         { font-size: 19px; margin-bottom: 12px; }
    .au-s4-para          { font-size: 14px; }
  }
`;
/* Placeholder helper */
const ph = (w, h, label = "") =>
  `https://placehold.co/${w}x${h}/1a1a1a/555555?text=${encodeURIComponent(label)}`;

/* Breadcrumb chevron */
const BcArrow = () => (
  <svg width="8" height="8" viewBox="0 0 8 8" fill="none">
    <path d="M2 1l3 3-3 3" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default function AboutUsPage() {
  return (
    <div className="au">
      <style>{CSS}</style>

      {/* ══ 1. HERO ══ */}
      <section className="au-hero">
        {/* Replace src with your actual hero bg image */}
        <img className="au-hero-bg" src={HeroBgImg} alt="About Us Hero" />
        <div className="au-hero-overlay" />
        <div className="au-hero-content">
          <h1 className="au-hero-title">About Us</h1>
          <hr className="au-hero-divider" />
          <p className="au-hero-desc">
            Clean Air and the use of sustainable and renewable energy
            are challenges facing countries around the world.
          </p>
        </div>
      </section>

      {/* ══ 2. BREADCRUMB ══ */}
      <nav className="au-breadcrumb" aria-label="Breadcrumb">
        <div className="au-breadcrumb-inner">
          <a href="/" className="au-bc-item">Home</a>
          <span className="au-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="/about-us" className="au-bc-item">About Us</a>
          <span className="au-bc-sep"><img src={BcSepIcon} alt=""  /></span>
          <span className="au-bc-item active">Ador Clean Air</span>
        </div>
      </nav>

      {/* ══ 3. CONTENT — left text, right images ══ */}
      <section className="au-section3">
        <div className="au-inner">
          <div className="au-section3-grid">

            {/* Left — title + paragraphs */}
            <div className="au-s3-left">
              <h2 className="au-s3-title">
                Clean Air And The Use Of Sustainable And
                Renewable Energy Are Challenges Facing Countries
                Around The World.
              </h2>
              <p className="au-s3-para">
                India has a promising future. It is undergoing a fast-paced progress. The side-effects of air pollution are devastating.
              </p>
              <p className="au-s3-para">
                However, with a population of over 1.3 billion and the resources required to feed, power and shelter everyone, the country is dealing with unprecedented levels of growth and consequently high levels of pollution.
              </p>
              <p className="au-s3-para">
                Traditional methods for controlling pollution from coal based (brown energy) power plants increasingly are proving inadequate to attain the ever-increasing acceptable clean air standards being prescribed by pollution-control boards.
              </p>
              <p className="au-s3-para">
                ADOR ensures that families have long and healthy lives together, because they can breathe cleaner air. We do this through designing and manufacturing resilient technology solutions to scrub particulate matter from stacks and factory shop floors.
              </p>
            </div>

            {/* Right — 2 vertical images on top, 1 horizontal below */}
            <div className="au-s3-right">
              {/* Row 1: two vertical images */}
              <div className="au-s3-img-row1">
                <img
                  className="au-s3-img-vertical"
                  src={ContentImg1}
                  alt="Clean Air Solution 1"
                />
                <img
                  className="au-s3-img-vertical"
                  src={ContentImg2}
                  alt="Clean Air Solution 2"
                />
              </div>
              {/* Row 2: one horizontal image */}
              <img
                className="au-s3-img-horizontal"
                src={ContentImg3}
                alt="Clean Air Solution 3"
              />
            </div>

          </div>
        </div>
      </section>

      {/* ══ 4. ABOUT COMPANY — bg #F5F5F5, img left, text right ══ */}
      <section className="au-section4">
        <div className="au-inner">
          <div className="au-section4-grid">

            {/* Left — image */}
            <div className="au-s4-img-wrap">
              <img className="au-s4-img" src={Section4Img} alt="Ador Powertron" />
            </div>

            {/* Right — title + paragraphs */}
            <div className="au-s4-text">
              <h2 className="au-s4-title">
                ADOR POWERTRON Ltd., an ISO 9001 certified
                company, is one of the largest manufacturer and
                supplier of Transformer-Rectifier (T/R) sets and
                controls in the world
              </h2>
              <p className="au-s4-para">
                With over 20,000+ High-Voltage Transformer-Rectifiers units supplied & 200+ satisfied customers over the past 25 years to its credit, it has earned a strong footprint within the Power, Cement, Steel, Pulp and Paper Industries across 42 countries spanning 6 continents.
              </p>
              <p className="au-s4-para">
                ADOR T/Rs use software developed in-house. In addition, it is able to incorporate OEM's software for management and control of the ESP.
              </p>
              <p className="au-s4-para">
                ADOR has committed to invest in these areas and will research innovative solutions to fight the issues of pollution and sustainable energy. As a step towards achieving this goal, Ador has a strategic technology-sharing partnership with Redkoh, the world's foremost precipitator controls company.
              </p>
            </div>

          </div>
        </div>
      </section>

    </div>
  );
}